/**
 * „Съобщете за грешка“ on a book or series page (issue #26): a wrong title,
 * a bad order, a synopsis that is off. It opens the contact form with the
 * page already named, so the reader does not have to say which one.
 *
 * The page travels as ?about=, validated by the contact form as a path on
 * this site (shared/return-path.ts) before it is written into the message.
 */

import { Link, useLocation } from 'react-router'
import { useI18n } from '../i18n/index.tsx'

export function ReportError() {
  const { t } = useI18n()
  const { pathname } = useLocation()
  return (
    <p className="report-error">
      <Link to={`/contact?about=${encodeURIComponent(pathname)}`}>{t('report.link')}</Link>
    </p>
  )
}
